import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-popup',
    template: `
<div class="popup-overlay" (click)="close.emit()"  >
  <div class="popup-container">
    <div class="close-button" (click)="close.emit()">
      <span class="close-icon">&times;</span>
    </div>
    <div class="popup-content">
      <img [src]="imageSrc" alt="Popup Image" onerror="this.src='/assets/images/icons/default.svg'"/>
    </div>
  </div>
</div>
  `,
    styles: [
        `
.popup-overlay {
  /* position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; */

   /* Adjust the z-index to make the overlay topmost  */

  position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    opacity: 1;
    transition: opacity linear 0.1s;
}

.popup-container {
  background: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  width: 60%;
  max-width: 650px;
  text-align: center;
  position: relative;
  z-index: 1001; /* Adjust the z-index to make the container topmost */
}

.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.close-icon {
  font-size: 18px;
  color: #aaa;
  transition: color 0.3s ease;
  margin-right: 10px;
}

.close-icon:hover {
  color: #e74c3c;
}

.popup-content img {
  max-width: 100%;
  height: auto;
  max-height: 700px;
}
:host ::ng-deep  .asap-layout-navbar {
    opacity: 0.3 !important;
}
    `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PopupComponent {
  @Input() imageSrc: string; // Define the 'imageSrc' property
  @Output() close = new EventEmitter<void>();

}
